var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('img',{attrs:{"src":require("../images/error.png"),"alt":""}}),_c('div',[_c('div',{staticClass:"error-code"},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('span',[_vm._v(_vm._s(_vm.argum))])]),_c('ul',{staticClass:"help-main"},[_c('li',{staticClass:"helpChil"},[_vm._v(_vm._s(_vm.help))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }